import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

export const initialState = {
  channelWorkflowGridState: null,
  channelWorkflowGridStateUpdate: null,
  channelWorkflowGridDataUpdate: null,
  channelWorkflowGridLayouts: null,
  channelWorkflowGridSelectedLayoutId: null,
  channelWorkflowGridLayoutIsDiverted: false,
  descriptiveFitDetails: null,
  channelWorkflowLoadingOverlayState: {
    isLoading: false,
    message: null
  }
}

// create slice will call createAction and createReducer for us internally
const slice = createSlice({
  name: 'channelWorkflowSlice',
  initialState,
  reducers: {
    setChannelWorkflowGridState: { // Optional 2nd paramater will merge instead of replacing state
      reducer: (state, action) => {
        state.channelWorkflowGridState = action.payload
      },
      prepare: (state, isUpdate) => ({ payload: { state, isUpdate } })
    },
    setChannelWorkflowGridStateUpdate: { // Optional 2nd paramater will merge instead of replacing state
      reducer: (state, action) => {
        state.channelWorkflowGridStateUpdate = action.payload
      },
      prepare: (state, isUpdate) => ({ payload: { state, isUpdate } })
    },
    setChannelWorkflowGridDataUpdate: (state, action) => {
      state.channelWorkflowGridDataUpdate = action.payload;
    },
    setDescriptiveFitDetails: (state, action) => {
      state.descriptiveFitDetails = action.payload;
    },
    setChannelWorkflowGridLayouts: (state, action) => {
      state.channelWorkflowGridLayouts = action.payload;
    },
    setChannelWorkflowGridSelectedLayoutId: { // Triggers channelWorkflowGridLayoutSaga
      reducer: (state, action) => {
        state.channelWorkflowGridSelectedLayoutId = action.payload.layout
      },
      prepare: (layout, layoutType, shouldFetch) => ({ payload: { layout, layoutType, shouldFetch } })
    },
    setChannelWorkflowGridLayoutIsDiverted: (state, action) => {
      state.channelWorkflowGridLayoutIsDiverted = action.payload;
    },
    setChannelWorkflowLoadingOverlayState: (state, action) => {
      state.channelWorkflowLoadingOverlayState = action.payload;
    },

    // Redux saga actions, no reducers
    fetchChannelWorkflowGridLayouts: () => { }, // Triggers channelWorkflowGridLayoutSaga
    saveChannelWorkflowGridLayout: { // Triggers channelWorkflowGridLayoutSaga
      reducer: () => { },
      prepare: (req, layoutType, callback) => ({ payload: { req, layoutType, callback } })
    },
    updateChannelWorkflowGridLayout: { // Triggers channelWorkflowGridLayoutSaga
      reducer: () => { },
      prepare: (req, layoutType, callback) => ({ payload: { req, layoutType, callback } })
    },
    deleteChannelWorkflowGridLayout:  { // Triggers channelWorkflowGridLayoutSaga
      reducer: () => { },
      prepare: (id, layoutType, callback) => ({ payload: { id, layoutType, callback } })
    },
    favoriteChannelWorkflowGridLayout:  { // Triggers channelWorkflowGridLayoutSaga
      reducer: () => { },
      prepare: (id, isFavorite, layoutType, successCallback, errorCallback) => ({ payload: { id, isFavorite, layoutType, successCallback, errorCallback } })
    }
  }
});

export default slice.reducer;

export const channelWorkflowActions = slice.actions;

// Memoized selectors
export const channelWorkflowSelectors = {
  channelWorkflowStateSelector: createSelector(
    state => state.channelWorkflowState,
    channelWorkflowState => channelWorkflowState
  ),
  channelWorkflowGridSelectedLayoutIdSelector: createSelector(
    state => state.channelWorkflowState,
    channelWorkflowState => channelWorkflowState.channelWorkflowGridSelectedLayoutId
  ),
  channelWorkflowGridOldestLayoutIdSelector: createSelector(
    state => state.channelWorkflowState.channelWorkflowGridLayouts,
    channelWorkflowGridLayouts => {
      if (!channelWorkflowGridLayouts?.length) return null;
      return channelWorkflowGridLayouts.slice().sort((a,b) => a.createdOn - b.createdOn)[0].id;
    }
  )
};